import { useTranslation } from "react-i18next";
import { hasTravelDatesPassed, type TripDto } from "@tc/shared";
import { Icon, Tag } from "@/components/ui";

/** The viewer's local calendar date as `YYYY-MM-DD` (travel dates are date-only, local-day semantics). */
function localTodayIso(): string {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}

/**
 * Warning shown under a trips-table row's dates when both travel dates are in the past but the trip
 * is still open (not Completed/Cancelled) — a prompt to resolve it. Renders nothing otherwise.
 */
export function DatesPassedTag({ trip }: { trip: Pick<TripDto, "status" | "travelStartDate" | "travelEndDate"> }) {
  const { t } = useTranslation();
  if (!hasTravelDatesPassed(trip, localTodayIso())) return null;
  return (
    <div className="trip-dates-warning">
      <Tag variant="warning" title={t("trips.datesPassedHint")}>
        <Icon name="alert" size={12} />
        {t("trips.datesPassed")}
      </Tag>
    </div>
  );
}
